import { ServiceUnavailablePage } from "@lyfegen-platform/react-common";
import { useTranslation } from "react-i18next";

export default function MaintenancePage() {
	const { t } = useTranslation();

	const checkServiceAvailability = () => {
		window.open("https://lyfegen-health-checks.azurewebsites.net/client-public", "_blank", "noopener,noreferrer");
	}

	return (
		<div style={{ position: "fixed", top: 0, bottom: 0, left: 0, right: 0, zIndex: 1202, backgroundImage: "linear-gradient(to bottom, #fbf8f5 0%, #ffffff 100%)" }}>
			<ServiceUnavailablePage
				header={t("maintenance-error-header")}
				description={t("maintenance-error-description")}
				buttonText={t("check-service-availability")}
				buttonAction={checkServiceAvailability}
			/>
		</div>
	);
}
